import storage from '../../../js/document/web-storage'

const cookieNames = {
  userData: 'user-data'
}

export const getProfileData = () => {
  const userDataCookie = storage.cookie.get(cookieNames.userData)

  if (!isValidUserDataCookie(userDataCookie)) {
    return { isUserLoggedIn: false }
  }

  const profileData = base64DecodeStrToObj(userDataCookie.profileData)

  if (!profileData) {
    return { isUserLoggedIn: false }
  }

  return {
    isUserLoggedIn: true,
    profileName: profileData.profileName || '',
    profileId: profileData.userId || '',
    isSunwebCE: profileData.isSunwebCE || false
  }
}

const isValidUserDataCookie = (userData) => {
  return userData &&
    userData.profileData &&
    userData.expirationDateTime &&
    new Date(userData.expirationDateTime) > new Date()
}

const base64DecodeStrToObj = (str) => {
  try {
    const base64 = decodeURIComponent(str)
    const jsonString = base64ToUtf8String(base64)
    return JSON.parse(jsonString)
  } catch (e) {
    if (window.newrelic) {
      window.newrelic.noticeError(e)
    }
    return null
  }
}

const base64ToUtf8String = (base64) => {
  const binString = atob(base64)
  const bytes = Uint8Array.from(binString, (m) => m.charCodeAt(0))
  return new TextDecoder().decode(bytes)
}
